
import {getVideoSlug} from "../ShowPage/helpers";

export function getAdTargetsForCurrentPage() {
    let targets = {};

    if (window.initialShow && window.initialShow.hasOwnProperty("id")) {
      targets["show"] =  window.location.pathname.replace(/\//g, "");
      targets["show-id"] = window.initialShow.id
    }

    if (isVideoUrl(window.location.href)) {
      targets["video"] = getVideoSlug(window.location.href);
    }

    return targets;
}

export function isVideoUrl(path: string) {
  return !! getVideoSlug(path);
}
